import { render, staticRenderFns } from "./WeetTimeLinePlayer.vue?vue&type=template&id=3487a950&scoped=true"
import script from "./WeetTimeLinePlayer.vue?vue&type=script&lang=ts"
export * from "./WeetTimeLinePlayer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3487a950",
  null
  
)

export default component.exports